import React from 'react';
import {Prompt, Redirect} from 'react-router-dom';
import uniqid from 'uniqid';
import TransitionModal from './TransitionModal';

class PreventTransitionPrompt extends React.Component {
  /**
   * Dialog state
   */
  state = {
    open: false,
    nextLocation: null,
    redirect: false,
  };

  constructor() {
    super();

    // Define a unique global symbol to store
    // a dialog trigger reference accessible via
    // a string key. Use cuid for unique ID.
    this.__trigger = Symbol.for(`__PreventTransitionPrompt_${uniqid()}`);
  }

  /**
   * Attach global dialog trigger for this component
   * instance to our Symbol trigger
   */
  componentDidMount() {
    window[this.__trigger] = this.show;
  }

  /**
   * Ensure we clean up and remove the reference
   * from the global object
   */
  componentWillUnmount() {
    delete window[this.__trigger];
  }

  render() {
    const {when} = this.props;
    const {open} = this.state;

    return (
      <>
        {this.state.redirect ? (
          <>
          <Redirect to={this.state.nextLocation} />
          </>
        ) : (
          <React.Fragment>
            {/* React Router prompt, callback will return true to allow transition or dialog key to prevent */}
            <Prompt when={when} message={this.handleTransition} />
            <TransitionModal
              open={open}
              toggleModal={this.toggleModal}
              onCancel={this.handleClose}
              onOk={this.handleRedirect}
            />
          </React.Fragment>
        )}
      </>
    );
  }

  /**
   * Show the dialog. Invoked primarily from React Router transition
   * handler getUserConfirmation.
   *
   * @param allowTransitionCallback A function that accepts a flag whether or not to allow the route transition
   */
  show = (allowTransitionCallback) => {
    // we are immediately preventing any transitions here
    // but could just as easily base this off a user interaction
    // or other state
    this.setState({open: true}, () => allowTransitionCallback(false));
  };

  /**
   * Closes the dialog
   */
  toggleModal = () => {
    this.setState({open: !this.state.open});
  };
  handleClose = () => {
    this.setState({open: false});
  };

  handleRedirect = () => {
    this.setState({redirect: true});
  };

  /**
   * Handles the Router transition. Returns true if allowed
   * or the dialog trigger key to enable the dialog.
   *
   * This would be a good candidate to allow optionally
   * being passed as a callback prop to let
   * caller decide if transition is allowed.
   */
  handleTransition = (location) => {
    // example: allow transitions to /two
    // if (location.pathname === "/two") {
    //     return true;
    // }

    this.setState({nextLocation: location.pathname});

    return Symbol.keyFor(this.__trigger);
  };
}

export default PreventTransitionPrompt;
